import React from 'react';
import Container from "../../../../components/paper/container";
import SectionTitle from "../../../../components/heading/section";
import P1 from "../../../../components/paragraph";
import HomeStoryWrap from "./style/wrap";

const AriannaStory = () => {
    return (
        <HomeStoryWrap id='arianna'>
            <Container>
                <SectionTitle>Arianna's Story - Sexual Abuse of a Minor</SectionTitle>
                <P1>
                    Arianna was sexually abused by her maternal grandfather, Ganraj Kumar (GK) while she was sleeping at his
                    house. She was one and half years old at the time of the incident. Ganraj Kumar was standing over
                    Arianna molesting her with one hand and masturbating himself with the other. Arianna's father Daya Baran
                    (Daya) walked into the room and witnessed the incident. Arianna's father (Daya) asked Ganraj Kumar what
                    he was doing. GK calmly put his penis into his pajamas, stared at the visibly shaken dad (Daya) in the
                    eye and walked out of the room without saying a word. When Daya told Arianna's mother what he witnessed,
                    she said to forget about it. Daya then told his brother-in-law Vikaash Kumar (VK), he said that it was a
                    family matter and there was no need to involve authorities. Daya was tormented. The marriage started to
                    crumble over Arianna's mother's insistence that Daya not report the incident to police. Unbeknownst to
                    Daya, his wife, her brother VK and her father GK had been consulting with lawyers, planning, plotting,
                    taking measures to silence and eliminate Daya. Daya told Ariann's mother (his now ex-wife) that he had
                    decided to report her father to authorities. The next day she served him with divorce papers falsely
                    alleging domestic violence. Daya was thrown out of his house, he was homeless and he had to fight to see
                    his daughter. In the last seven years he has seen his daughter for just 40 hours.
                </P1>
                <P1>
                    What ensued next was beyond anyone's worst nightmare. Daya thought he would fight it out in court where
                    the truth would previal. But nothing could be further from the truth. The California Family Court System is
                    a money making scheme profiting the Attorney General of California, corrupt judges, unscrupulous
                    fraudulent lawyers, bogus child specialists, therapists, psychologists, child support services and a long list of
                    parasites that make a living trafficking and preying on children and parents in divorce. It is an
                    organized criminal enterprise benefiting that is funding the lifestyles of corrupt judges and lawyers at the
                    expense of families and kids.
                </P1>
            </Container>
        </HomeStoryWrap>
    );
};

export default AriannaStory;
